import React from "react";
// import "./Systems.css";

function Systems() {
  return (
    <div className="content-container systems-page">
      <h2>Sanda / San Shou 散手</h2>
      <p>
        <img src="/sanshou.gif" className="left" alt="sanda" />
        EBM Kung Fu offers instruction in Sanda to people of all levels. The
        Sanda training at EBM Kung Fu is very methodical, starting with
        principles of body mechanics, power, balance and footwork and the
        practice of shadowboxing. The student then progresses to training with a
        partner to learn proper offense, defense, fighting tactics and
        strategies. Sanda encompasses both the striking arts as well as the
        grappling arts to produce a very practical and well rounded system. Free
        sparring and competition are an optional part of the training for those
        who have mastered the fundamentals. Sanda is the official full contact
        fighting sport of modern Chinese Wushu which is rapidly growing in
        international popularity. As an integral part of most Wushu
        competitions, Sanda has been an important event at the World Wushu
        Championships since its inception in 1991. Presently, Sanda competitions
        are held in over 80 countries worldwide. Recently Sanda has also become
        a professional sport in America. The word "Sanda" also spelled "San
        Shou" translates as "unbound hand" and refers to free fighting where the
        rules are designed to most accurately simulate actual combat. Sanda
        matches are fought on a raised platform called the "Lei Tai".
        Historically, the Lei Tai dates back centuries in China where challenge
        matches were fought both bare handed and also with weapons with no
        rules. These matches often resulted in death or serious injury. At the
        National Chinese tournament in Nanking in 1928, the fights on the Lei
        Tai were so brutal that the final 12 contestants were not permitted to
        fight for fear of killing off some of the great masters of the time. So
        changes were needed! Modern Sanda developed into a sport about the same
        time as modern Wushu during the 1960's by the Chinese Government. In
        order to define a standard kung fu fighting style, the great masters
        from all over China were given the task of organizing the huge heritage
        of Chinese martial arts in to a system of rules in which different
        styles could complete. Protective equipment was also added to further
        reduce the risk of serious injury. The rules of Sanda allow for a wide
        array of full contact punching, kicking, takedowns and throws derived
        from the traditional application of Chinese martial arts. Finishing
        holds (chokes, arm locks etc.) have been excluded from the rules which
        forces the fight to continue at a fast pace. Sanda addresses the three
        ranges of fighting-- kicking, punching and grappling which adds great
        realism to the sport. A fighter can win by a knockout or by points.
        Points are also awarded for the techniques according to effectiveness.
        In a tournament, you fight for 2 rounds of 2 minutes each, plus a third
        round in case the first 2 score even. Forcing the opponent off of the
        platform is also a major technique of Sanda. It is a mistake to think of
        Sanda as just Kick Boxing because the strategies of Sanda are much more
        complex. There is a now a saying is China:
        <quote>
          Sanda shi Wushu de Jinghua-- "Sanda is the quintessence of Wushu."{" "}
        </quote>
        EBM Kung Fu is the home of the Oakland Sanda Team which is one of the
        top Sanda Teams in the US with over 30 championship titles and 6
        National Champions.
      </p>
      <h2>Northern Shaolin 北少林</h2>
      <p>
        <img src="/shaolin.gif" className="left" alt="shaolin" />
        EBM Kung Fu offers instruction in Northern Shaolin to people of all
        levels. Northern Shaolin training is very rigorous and is an excellent
        way to get in shape and build a strong foundation for all martial arts
        training. At EBM Kung Fu we offer group classes in Northern Shaolin
        fundamentals which consists of linear drills back and forth across the
        room executing a variety of techniques with an emphasis on proper form,
        balance, power, speed and intention. This training build strength and
        flexibility throughout the body and teaches relaxation, focus and
        stamina.{" "}
        <quote>
          "Shaolin martial arts are as steady as a nail; cocked like a bow while
          turning like a leaf. Heavy as iron yet moving like a wave. As quiet as
          a mountain." -Chen Hsien Mon (Northern Shaolin Master)
        </quote>{" "}
        The history of Northern Shaolin Kung Fu stretches back to the year
        495AD, when the Shaolin Buddhist monastery was built in Honan province
        in Northern China. The temple was built under the order of Su Wen in
        adoration of the Buddhist master Badra. In order to defend the temple
        from attackers and thieves, the monks developed martial arts which
        combined combat techniques with the theories and practices of Buddhist
        meditation. Today a general distinction of the kung fu styles in China
        is between "Northern" and "Southern" styles. This is not only a
        distinction of geography but also of the techniques and methods
        themselves. The Southern styles of kung fu are characterized as having
        short fast hand strikes and low kicks. The Southern styles are often
        referred to as "short fist" styles. Two examples of Southern kung fu are
        "Wing Chun" and "Hung Gar". The Northern styles of kung fu emphasize
        extension in striking, with deep stances and dynamic kicking methods.
        The Northern styles develop flexibility, strength, coordination, balance
        and agility. The theory of Northern style is that power is developed
        through the rigorous training of the extended postures which one can
        condense into shorter strikes when actually fighting. The training also
        instills a great amount of versatility in movement and technique.
        Another distinction that is important to note is between traditional
        Northern Shaolin Kung Fu and what is commonly known as "wu shu". During
        the cultural revolution in China, martial arts were organized into
        sports and the forms of Northern Shaolin were modified into performance
        routines for competition-- which became commonly referred to as "wu
        shu". Wu shu emphasizes the aesthetics of the martial arts over the
        practical fighting principles and it is a bit like acrobatics. At EBM we
        offer more traditional Shaolin martial arts where the emphasis is on
        fighting technique and power.
        <quote>
          "A good defense is a strong offense. Be aggressive in attacking,
          whether it is a feint or a direct attack. Keep in mind that a good
          fighter defeats his opponent in three to five moves. If this condition
          is not met, then your opponents abilities are either equal to or
          better than yours. Whenever possible, counterattack at angles by
          sidestepping toward the opponents weak side. The three components of
          combat are 1.) Speed 2.) Guts 3.) Techniques. All three components go
          hand and hand. One component cannot survive without the others...
          Attack like the waves of the ocean crashing against the beach." -Wong
          Jack Man (Northern Shaolin Master)
        </quote>{" "}
        At the EBM Academy, we teach the traditional Northern style of Shaolin.
        This system is the largest of the lineages taught at EBM and is taught
        in a very systematic fashion. Tan Tui ("spring leg") is the system of
        basic forms which is the foundation of Northern Shaolin. Tan Tui
        consists of twelve linear forms which are done in repetition as solo
        practice, and then twenty four fighting forms which are done with a
        partner. Tan Tui provides an excellent foundation for the martial arts.
        Tan Tui develops strength, flexibility, proper body mechanics,
        cardiovascular endurance and hard bones.
        <quote>
          "Learning martial arts is like tempering a sword, it must be heated
          and sharpened again and again in order to make it a powerful weapon."
          --Wan Li Sheng (Northern Shaolin, Tzu Jan Master)
        </quote>{" "}
      </p>
      <h2>Taiji Quan 太極拳</h2>{" "}
      <p>
        <img src="/taichi.gif" className="left" alt="sanda" />
        EBM Kung Fu offers instruction in Kuo Style Taiji to people of all
        levels. At EBM Kung Fu we teach Taiji as a martial art with very
        detailed instruction in the body mechanics and principles of cultivating
        power through the concepts of Taiji.
        <quote>
          Give evil nothing to oppose and it will disappear by itself. ― Lao
          Tzu, Tao Te Ching{" "}
        </quote>
        Taiji is a Taoist internal martial art. One account of the history of
        Taiji credits its development to the Taoist immortal Chang San-feng, who
        is said to have drawn the inspiration for the art by watching a fight
        between n snake and an aggressive eagle. Chang San-feng was reportedly a
        master of Shaolin Kung Fu who reached an extraordinary level of
        cultivation through Taoist meditation practices. Another account of the
        history of Taiji is that many different Kung Fu masters developed it
        over a long period of time; as a synthesis of internal meditation and
        martial technique. Either way, the written history of Taiji goes back
        about 300 years and it was not until the turn of the 20th century that
        it was introduced to the general public. Taiji is a very unique and
        powerful art, for both internal power and longevity. Taiji is a martial
        art which embodies Taoist philosophy. When Taiji was developed, the
        martial arts were very aggressive. One's proficiency was measured by the
        strength and aggression of attack, in terms of the Taoist principle of
        yin and yang this was a purely "yang" conception of martial arts. What
        was revolutionary about Taiji was the incorporation of the yin element
        to fighting. In Taiji one uses a balance of yin techniques with yang
        techniques, a balance between yielding and attacking. It is for this
        reason that Taiji is described as "a needle hidden in cotton" or
        "hardness concealed in softness". Presently Taiji is rapidly growing in
        popularity for the tremendous health benefits which come through
        practice. Clinical studies have shown that Taiji practice can lower
        blood pressure, reduce nervous tension, and benefit the immune,
        digestive, cardiovascular and respiratory systems. At this time, over
        one hundred million people practice Taiji Ch'uan on a regular basis. The
        Taiji which is taught at EBM is Yang family style. The form we practice
        was developed by Li Ching Lin who learned from both Sun Lu Tang and Yang
        Chien Hou. Li Ching Lin then taught Kuo Yu Chang, who taught Yim Shan
        Wu, who taught Wong Jack Man, all of the EBM Instructors learned Taiji
        from Wong Jack Man. The heart of the Taiji system is the practice of the
        single Taiji form. The form practice of Taiji is the foundation of the
        training. Though Taiji is done slowly, the movements are very difficult
        and strenuous. Regular practice of Taiji Ch'uan greatly improves the
        functioning of the bodily systems. Taiji practice breaks down into three
        general categories: 1. Ch'i kung practice for developing the foundation
        of internal martial arts: proper stance, proper breathing technique,
        flexibility and power. 2. Solo form practice (i.e. "Taiji long form")
        for developing the basic techniques of Taiji Ch'uan, and developing
        strength, relaxation and sensitivity. 3. Partner practice (i.e. "Taiji
        Push Hands") for understanding the application of the form, developing
        sensitivity to the opponents movement and intention.
        <quote>
          Stiff and unbending is the principle of death. Gentle and yielding is
          the principle of life. Thus an Army without flexibility never wins a
          battle. A tree that is unbending is easily broken. The hard and strong
          will fall. The soft and weak will overcome. ― Lao Tzu, Tao Te Ching
        </quote>
      </p>
      <h2>Xingyi Quan - 形意拳</h2>
      <p>
        <img src="/hsingi.gif" className="left" alt="sanda" />
        Xingyi translates to "form and intention boxing" or "body-mind boxing".
        The history of Xingyi is unclear. One account credits Boddhidharma with
        its creation; while others credit general Yeuh Fei of the Northern Sung
        Dynasty (960-1127). Hence, it is unclear whether Xingyi is a Taoist art
        like Taiji or a Buddhist art of the Shaolin temple. Chances are that it
        was developed by many masters both Taoist and Buddhist over an extended
        period of time. Like Taiji , Xingyi is considered an internal art.
      </p>
      <p>
        The three major schools of Xingyi are Honan, Shansi, and Hopei. Sun
        style Xingyi was developed by Sun Lu Tang, who learned the Hopei style
        from Guo Yun Shen. Hence, Sun Style is an outgrowth of the Hopei school,
        many consider Sun Lu Tang to be the highest level master of Hopei style
        Xingyi that has ever lived.
      </p>
      <p>
        The Xingyi Quan taught at EBM is authentic Sun style. The core of the
        training in Xingyi Quan are the Five Elements:
      </p>
      <ul>
        <li>Pi Ch'uan (splitting fist)</li>
        <li>Tsun Ch'uan (drilling fist)</li>
        <li>Bong Ch'uan (crushing fist)</li>
        <li>Pao Ch'uan (pounding fist)</li>
        <li>Heng Ch'uan (crossing fist)</li>
      </ul>
      <p>
        The Five Elements are the foundation of Xingyi and this cannot be
        emphasized enough. After one has reached proficiency in the five
        elements, the next two forms are "fighting forms" which are done with a
        partner. The first fighting form utilizes three elements done in
        sequence, the next utilizes all five elements, these develop the
        techniques into practical application. The next solo forms are:
      </p>
      <ul>
        <li>Lien Huan (linking five elements)</li>

        <li>Pat Sik (eight methods)</li>
      </ul>
      Following the linking forms are the twelve animal forms:
      <ul>
        <li>Hawk </li>
        <li>Swallow</li>

        <li>Rooster</li>
        <li>Dove</li>
        <li>Snake</li>
        <li>Tiger</li>
        <li>Bear and Eagle</li>
        <li>Turtle</li>
        <li>Horse</li>
        <li>Monkey</li>
        <li>Dragon</li>
      </ul>
      <p>
        Following the twelve animals, is the twelve animals linking (Chop Sik
        Choy) form which develops the ability to link different techniques
        together in various ways. The final fighting set is the "fighting animal
        two man form" (En Tsan Pao) which is the essential form for developing
        real Hsing I fighting ability.
      </p>
      <p>
        The final aspect of Xingyi training is the two handed sword. Since the
        Xingyi sword is much like the Japanese samurai sword, it is possible
        that the Xingyi style of swordsmanship is the true origin of the samurai
        style. The sword is practiced in a similar fashion to the five elements.
        There are five forms to the Hsing I sword, as well as countless two
        person fighting forms.
      </p>
      <h2>Qigong 氣功</h2>{" "}
      <p>
        <img src="/chikung.gif" className="left" alt="sanda" />
        At The EBM Kung Fu Academy, nothing is stressed more than the basics.
        Without a solid foundation, it is very difficult to make progress. All
        martial art forms as well as free fighting require that one has a strong
        foundation. At EBM we supplement all of the martial arts that we teach
        with extensive Qigong practices and body conditioning systems. The
        Qigong systems that we teach in their entirety are the following: The
        <ul>
          <li>108 Lohan Kung Fu Strength & Conditioning Series</li>
          <li>Muscle Sinew Washing Bone Marrow Washing</li>
          <li>Northern Star Qigong</li>
          <li>Huashan Series</li>
          <li>Crane Qigong</li> <li>Taiji Ho Shi Fa</li>
          <li>Xingyi Dragon Body Series</li>
          <li>Various Standing Meditation</li>
        </ul>
        Methods Qigong practice strengthens the body, regulates the vital fluids
        (jing), builds physical energy (ch'i) and cultivates ones mental
        concentration and spirit (shen). Regular practice of Qigong develops a
        deeper understanding of the internal aspect of the martial arts. Body
        conditioning is an essential aspect of all the training at EBM. Having a
        strong constitution is essential for anyone interested in the fighting
        aspect of martial arts. Most of the conditioning exercises taught at EBM
        are from the 108 Lohan exercises as taught by Grand master Kwan Sai
        Hung. The Lohan series consists of solo and two person strengthening
        exercises that utilize every part of the body. The series is extremely
        rigorous and effective for any style of martial art. The 108 Lohan
        series is a very involved system in its own right.
        <quote>
          Toughen my sinews, harden my bones, Make my blood flow freely, I will
          then be young forever In touch with the realm of gods. - Canon of the
          Great Void (Classic Taoist Text)
        </quote>
      </p>
    </div>
  );
}

export default Systems;
